import { Button, Menu, MenuDivider, MenuItem } from '@blueprintjs/core';
import { Popover2 as Popover } from '@blueprintjs/popover2';
import { mdiHelpCircle, mdiOpenInNew } from '@mdi/js';
import { Icon } from '@mdi/react';
import React from 'react';
import { useSelector } from 'react-redux';
import { t } from 'ttag';
import { useGetOrganizationQuery } from 'uf-api-rtk/store/Api';
import { selectApp } from 'uf/app/slice';
import { logEvent } from 'uf/logging';
import { IconSizeNew } from 'uf/ui/base/icon';
import { sources } from 'uf/ui/user/logging';
import {
  FEATURE_DOCUMENTATION_OPENED,
  RESILIENCE_INSIGHTS_HELP_OPENED,
} from 'uf/user/logging';

const HelpMenu = () => {
  const { activeProjectId, activeOrgId } = useSelector(selectApp);
  const { data: organization } = useGetOrganizationQuery(
    { key: activeOrgId },
    { skip: !activeOrgId },
  );

  const handleClick = event => {
    logEvent(event, {
      projectId: activeProjectId,
      source: sources.HELP_MENU,
    });
  };

  const openInNewIcon = (
    <Icon path={mdiOpenInNew} size={IconSizeNew.EXTRA_SMALL} />
  );

  return (
    <Popover
      content={
        <Menu data-testid="HelpMenu">
          <MenuDivider title={t`Resources`} />
          <MenuItem
            text={t`Analyst help`}
            icon={openInNewIcon}
            href="https://help.urbanfootprint.com"
            target="_blank"
            rel="noreferrer noopener"
            onClick={() => handleClick(FEATURE_DOCUMENTATION_OPENED)}
          />
          {!!organization?.insights_help_url && (
            <MenuItem
              text={t`Resilience Insights help`}
              icon={openInNewIcon}
              href={organization.insights_help_url}
              target="_blank"
              rel="noreferrer noopener"
              onClick={() => handleClick(RESILIENCE_INSIGHTS_HELP_OPENED)}
            />
          )}
        </Menu>
      }>
      <Button
        minimal
        className="tw-p-0 tw-text-blueGray-400 hover:tw-text-white tw-h-full tw-w-16"
        icon={<Icon path={mdiHelpCircle} size={IconSizeNew.SMALL} />}
      />
    </Popover>
  );
};

export default HelpMenu;
